import styled from 'styled-components';

const LiHeader = styled.li`
  display: inline-block;
  font-size: 24px;
  margin: 0 8px;
`;

export default LiHeader;
